import participantService from '../services/participantService';

/**
 * Enriquece concursos con actualParticipantCount usando una sola petición bulk
 * en lugar de N llamadas a /participants/count/:id.
 */
export async function attachParticipantCountsBulk(contestsData: any[]): Promise<any[]> {
  if (!Array.isArray(contestsData) || contestsData.length === 0) {
    return [];
  }

  const contestIds = contestsData.map((contest) => contest?.id).filter(Boolean) as string[];

  try {
    const counts = await participantService.getParticipantCountsByContestIds(contestIds);
    return contestsData.map((contest) => ({
      ...contest,
      actualParticipantCount: counts[contest.id] ?? contest.current_participants ?? 0,
    }));
  } catch (error) {
    console.error('Error loading bulk participant counts, falling back to stored values:', error);
    return contestsData.map((contest) => ({
      ...contest,
      actualParticipantCount: contest.current_participants ?? 0,
    }));
  }
}
